import { useRef, useState } from "react";
import { useTranslations } from "next-intl";
import { getListingTitle } from "@/lib/string-utils";
import type { DetailedListing } from "@/lib/types";

export function useInquiryMessage(listing: DetailedListing) {
  const t = useTranslations();
  const [message, setMessage] = useState(
    t("saas.listing.sidebar.contactLoggedIn.form.fields.message.placeholder", {
      listingTitle: getListingTitle(t, listing),
    }),
  );
  const messageRef = useRef(message);
  messageRef.current = message;
  function handleTextareaFocus(e: React.FocusEvent<HTMLTextAreaElement>) {
    const defaultMsg = t(
      "saas.listing.sidebar.contactLoggedIn.form.fields.message.placeholder",
      { listingTitle: getListingTitle(t, listing) },
    );
    if (e.target.value === defaultMsg) {
      setMessage("");
    }
  }

  function handleTextareaBlur(e: React.FocusEvent<HTMLTextAreaElement>) {
    if (e.target.value.trim() === "") {
      setMessage(
        t(
          "saas.listing.sidebar.contactLoggedIn.form.fields.message.placeholder",
          { listingTitle: getListingTitle(t, listing) },
        ),
      );
    }
  }

  return {
    message,
    setMessage,
    messageRef,
    handleTextareaFocus,
    handleTextareaBlur,
  };
}
